export const INFRASTRUCTURE_MF_NAME = 'map-search-frontend';
export const MORTGAGE_MINI_CALCULATOR_MF_NAME = 'mortgage-mini-calculator';
